import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { mergeProps as _mergeProps, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
/* eslint-disable import/no-cycle */
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import useQueryData from './use-query-data';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
export type LinkProps = {
  to: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  children?: string | React.ReactNode | React.ReactNode[];
  className?: string;
  style?: React.CSSProperties;
} & React.HTMLProps<HTMLAnchorElement>;
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({
  to,
  children,
  onClick,
  ...props
}, ref) => {
  const {
    permalink,
    isMicrosite
  } = useMicrosite();
  const [path, queryString, hash] = useQueryData(to);
  const linkIsExternal = path.includes(':');
  if (linkIsExternal) {
    return <a {..._mergeProps({
      ref: ref,
      href: to,
      rel: "noreferrer noopener",
      target: "_blank"
    }, props)}>
                {children}
            </a>;
  }
  const pathPrefix = (() => {
    if (permalink && isMicrosite && path.startsWith('/') && !path.startsWith('/locations')) {
      return permalink;
    }
    return '';
  })();
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <GatsbyLink
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    {..._mergeExternalProps({
      ref: ref,
      to: `${pathPrefix}${path.replace(pathPrefix, '')}${queryString}${hash}`,
      onClick: onClick
    }, props)}>
            {children}
        </GatsbyLink>
  );
});
Link.displayName = 'Link';
export default Link;